import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Folding an AG-UI event stream into a single run result.
 *
 * This is the stateful half of a chat turn, and the half worth isolating: it
 * owns the in-flight tool calls, the accumulating text, and the guarantee that
 * `onDone` fires exactly once. The client only feeds it events, so none of that
 * bookkeeping is entangled with fetch, auth or retries.
 */

export var RunAccumulator = /*#__PURE__*/function () {
  function RunAccumulator() {
    var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, RunAccumulator);
    /**
     * Tool calls awaiting their END frame, keyed by id. A map rather than a stack
     * because calls interleave: the model can open a second call before the first
     * one's arguments have finished streaming, so nesting cannot be assumed.
     */
    _defineProperty(this, "open", new Map());
    _defineProperty(this, "doneFired", false);
    /** Set when a RUN_ERROR arrives, so streamChat can reject the run: the
     *  chat state machine learns a turn failed only from a rejected promise. */
    _defineProperty(this, "errored", undefined);
    this.result = _objectSpread({
      text: "",
      finished: false,
      toolCalls: []
    }, seed);
  }

  /** Fold one event in, invoking the matching handler. */
  return _createClass(RunAccumulator, [{
    key: "apply",
    value: function apply(ev, handlers) {
      var _handlers$onEvent, _handlers$onStart, _handlers$onText, _handlers$onError;
      (_handlers$onEvent = handlers.onEvent) === null || _handlers$onEvent === void 0 || _handlers$onEvent.call(handlers, ev);
      switch (ev.type) {
        case "RUN_STARTED":
          (_handlers$onStart = handlers.onStart) === null || _handlers$onStart === void 0 || _handlers$onStart.call(handlers, {
            threadId: ev.threadId,
            runId: ev.runId
          });
          break;
        case "RUN_FINISHED":
          // The authoritative completion signal. Settle now rather than at stream
          // close, so the UI stops spinning the moment the run is actually done.
          this.result.finished = true;
          this.finish(handlers);
          break;
        case "TEXT_MESSAGE_CONTENT":
        case "TEXT_MESSAGE_CHUNK":
          this.result.text += ev.delta;
          (_handlers$onText = handlers.onText) === null || _handlers$onText === void 0 || _handlers$onText.call(handlers, ev.delta);
          break;
        case "TOOL_CALL_START":
          {
            var _handlers$onToolStart;
            var call = {
              id: ev.toolCallId,
              name: ev.toolCallName,
              argsRaw: ""
            };
            this.open.set(call.id, call);
            (_handlers$onToolStart = handlers.onToolStart) === null || _handlers$onToolStart === void 0 || _handlers$onToolStart.call(handlers, {
              id: call.id,
              name: call.name
            });
            break;
          }
        case "TOOL_CALL_ARGS":
          {
            var _call = this.open.get(ev.toolCallId);
            if (_call) _call.argsRaw += ev.delta;
            break;
          }
        case "TOOL_CALL_END":
          {
            var _handlers$onToolEnd;
            var _call2 = this.open.get(ev.toolCallId);
            if (!_call2) break;
            this.open["delete"](_call2.id);
            _call2.args = tryParse(_call2.argsRaw);
            this.result.toolCalls.push(_call2);
            (_handlers$onToolEnd = handlers.onToolEnd) === null || _handlers$onToolEnd === void 0 || _handlers$onToolEnd.call(handlers, _call2);
            break;
          }
        case "TOOL_CALL_RESULT":
          {
            var _handlers$onToolResul;
            // The call has already been pushed to result.toolCalls by END, so this
            // updates that same object rather than adding another entry.
            var _call3 = this.result.toolCalls.find(function (c) {
              return c.id === ev.toolCallId;
            });
            if (!_call3) break;
            _call3.result = ev.content;
            (_handlers$onToolResul = handlers.onToolResult) === null || _handlers$onToolResul === void 0 || _handlers$onToolResul.call(handlers, _call3);
            break;
          }
        case "RUN_ERROR":
          // Record it so streamChat rejects. onError alone would let the run
          // resolve as an empty, "successful" turn and leave a blank bubble.
          this.errored = ev.message;
          (_handlers$onError = handlers.onError) === null || _handlers$onError === void 0 || _handlers$onError.call(handlers, ev.message);
          break;
        default:
          // Unknown types are ignored on purpose, so a future orqestrator release
          // that emits more events cannot break an older client.
          break;
      }
    }

    /**
     * Fire `onDone` if it has not fired yet.
     *
     * Idempotent because there are two paths to completion: a RUN_FINISHED event,
     * and the stream simply closing (abort, dropped connection, a run that never
     * sends RUN_FINISHED). Both must clear the caller's spinner, and neither may
     * double-fire.
     */
  }, {
    key: "finish",
    value: function finish(handlers) {
      var _handlers$onDone;
      if (this.doneFired) return;
      this.doneFired = true;
      (_handlers$onDone = handlers.onDone) === null || _handlers$onDone === void 0 || _handlers$onDone.call(handlers);
    }
  }]);
}();

/** Arguments that are partial or not JSON are not worth failing a run over. */
function tryParse(raw) {
  try {
    return raw ? JSON.parse(raw) : undefined;
  } catch (_unused) {
    return undefined;
  }
}